import React, { useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import EndCallButtonIcon from '../Buttons/EndCallButton/EndCallButtonIcon';
import useRoomState from '../../hooks/useRoomState/useRoomState';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { Grid, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText } from '@material-ui/core';
import ToggleAudioButtonIcon from '../Buttons/ToggleAudioButton/ToggleAudioButtonIcon';
import ToggleChatButtonIcon from '../Buttons/ToggleChatButton/ToggleChatButtonIcon';
import ToggleVideoButtonIcon from '../Buttons/ToggleVideoButton/ToggleVideoButtonIcon';
import ToggleParticipantsButtonIcon from '../Buttons/ToggleParticipantsButton/ToggleParticipantsButtonIcon';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: 'transparent',
      bottom: 0,
      left: 0,
      right: 0,
      height: `${theme.footerHeight}px`,
      position: 'fixed',
      display: 'flex',
      padding: '0 1.43em',
      zIndex: 10,
      [theme.breakpoints.down('sm')]: {
        height: `${theme.mobileFooterHeight}px`,
        padding: 0,
      },
    },
    border: {
      background: 'transparent',
      width: '200px',
      position: 'absolute',
      height: '160px',
      border: 'solid 1px white',
      borderRadius: '50%',
      bottom: '-110px',
    },
    dialogButton: {
      color: theme.palette.secondary.main, 
      fontWeight: 'bold'
    }
  })
);

export default function MenuBar() {
  const classes = useStyles();
  const { room } = useVideoContext();
  const roomState = useRoomState();
  const isReconnecting = roomState === 'reconnecting';
  
  // State for Modal
  const [isEndCallModalOpen, setIsEndCallModalOpen] = useState(false);

  const handleOpenEndCallModal = () => {
    setIsEndCallModalOpen(true);
  };

  const handleCloseEndCallModal = () => {
    setIsEndCallModalOpen(false);
  };

  const handleEndCallForMe = () => {
    console.log("DEBUG [MenuBar]: Saliendo solo yo (End call for me).");
    handleCloseEndCallModal();
    room.disconnect();
  };

const handleEndCallForEverybody = async () => {
    // 1. EL TICKET PARA EL HOST:
    // Marcamos inmediatamente para que el bloqueo sea instantáneo.
    window.sessionStorage.setItem('meeting_ended', 'true');
    console.log("DEBUG [MenuBar]: Marcando meeting_ended...");

    // 2. EXTRAER ID DE LA URL
    // Si la URL es https://fitafter50.xyz:8081/room/{id}/name
    // el pathname es /room/{id}/name. Al hacer split, el id queda en la posición [2].
    const pathSegments = window.location.pathname.split('/');
    const sessionId = pathSegments[2]; 

    const roomSid = room.sid;

    // 3. EJECUCIÓN DE APIS
    try {
        // Ejecutamos ambas peticiones en paralelo para mayor velocidad
        const requests = [];

        // API 1: Completar la sala en Twilio (tu API interna)
        if (roomSid) {
            requests.push(
                fetch('/api/complete-room', { 
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ roomSid }),
                })
            );
        }

        // API 2: Nueva API RESTful para finalizar la sesión en Laravel
        if (sessionId) {
            console.log(`DEBUG [MenuBar]: Finalizando sesión ID: ${sessionId}`);
            requests.push(
                fetch(`https://fitafter50.xyz/api/endSessions/${sessionId}`, {
                    method: 'POST',
                    headers: { 
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                })
            );
        }

        // Esperamos a que ambas APIs respondan
        await Promise.all(requests);
        console.log("DEBUG [MenuBar]: Todas las APIs externas actualizadas.");

    } catch (error) {
        console.error("DEBUG [MenuBar]: Error al sincronizar con el backend:", error);
    }

    // 4. DESCONEXIÓN Y CIERRE
    handleCloseEndCallModal();
    room.disconnect();
};

const handleCloseSession = () => {
   window.sessionStorage.setItem('meeting_ended', 'true');
   room.disconnect();

}

const urlParams = new URLSearchParams(window.location.search);
        const isEntrenador = urlParams.get('entrenador') === 'true';

  return (
    <>
      <footer className={classes.container}>
        <Grid container justifyContent="center" alignItems="center">
          <ToggleAudioButtonIcon disabled={isReconnecting} />
          <ToggleVideoButtonIcon disabled={isReconnecting} />
          {process.env.REACT_APP_DISABLE_TWILIO_CONVERSATIONS !== 'true' && <ToggleChatButtonIcon />}
          <ToggleParticipantsButtonIcon />
          
          {/* CORRECTED: Pass onClick directly as a prop. DO NOT wrap in a div. */}
          <EndCallButtonIcon onClick={isEntrenador ? handleOpenEndCallModal : handleCloseSession}/>

          <div className={classes.border}></div>
        </Grid>
      </footer>

      <Dialog
        open={isEndCallModalOpen}
        onClose={handleCloseEndCallModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"End Call?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            How would you like to leave the meeting?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEndCallForMe} color="primary">
            End call for me
          </Button>
          <Button onClick={handleEndCallForEverybody} className={classes.dialogButton} autoFocus>
            End call for everybody
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}